export default class UpdateAsignacionEquipo {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubSede, idDetalleAsignacion, payload) {
    try {
      const result = await this.#repository.updateAsignacion(idSubSede, idDetalleAsignacion, payload)
      return result
    } catch (error) {
      console.error('Error al actualizar la asignación de equipo:', error)
      throw error
    }
  }
}
